import { space } from '@guardian/source/foundations';

export const navInputCheckboxId = 'header-nav-input-checkbox';
export const veggieBurgerId = 'header-veggie-burger';
export const expandedMenuRootId = 'header-expanded-menu-root';
export const expandedMenuId = 'header-expanded-menu';

export const pillarLeftMarginPx = 6;

export const pillarWidthsPx = {
	tablet: 108,
	leftCol: 125,
	wide: 136,
};

export const smallMobilePageMargin = '10px';
export const pageMargin = `${space[5]}px`;

export const minHeaderHeightPx = 126;
